import { AccountData, OrderPageData } from '../../api';
import { OrderPageStatus } from '../../api/models/OrderPageStatus';
import { getOrderPages } from '../../utils/AccountUtils';
import { getActiveLocations, getEffectivePageLocationId, isMultiLocation } from '../../common/filter/locationGrouping';

export const getCalendarLocationIds = (
  account: AccountData,
  selectedOrderPageIds: string[] | null,
): string[] | null => {
  if (!isMultiLocation(account) || selectedOrderPageIds === null) {
    return null;
  }
  const activeOrderPages = getOrderPages(account).filter(
    (orderPage: OrderPageData) => orderPage.status !== OrderPageStatus.ARCHIVED,
  );
  const selectedOrderPages = activeOrderPages.filter((orderPage: OrderPageData) =>
    selectedOrderPageIds.includes(orderPage.id),
  );
  if (
    selectedOrderPages.length === activeOrderPages.length ||
    selectedOrderPages.some(
      (orderPage: OrderPageData) => getEffectivePageLocationId(orderPage.location_id, account) === null,
    )
  ) {
    return null;
  }
  return getActiveLocations(account)
    .filter((location) => selectedOrderPages.some((orderPage: OrderPageData) => orderPage.location_id === location.id))
    .map((location) => location.id);
};
